<template>
  <b-modal
    id="cadastro_pedido"
    header-bg-variant="info"
    :title="this.modalTitle"
    size="xl"
    hide-footer
    @shown="carregaDadosPedido"
    @close="this.onCloseModal"
    no-close-on-esc>
      <b-row>
        <b-col style="margin-left: 10px;margin-right: 10px;">
          <b-row cols="12" style="margin-left: 15px;margin-right: 15px;">
            <b-col sm="12" md="6" lg="6" xl="3">
              <label>Natureza da Operação *</label>
              <b-form-select
                data-live-search="true"
                id="pedido_natureza_operacao"
                v-model="pedidoDetail.NAT_OP"
                :options="naturezaOperacaoOptions"
                :disabled="(this.pedidoDetail.STATUS == 'F')"
              ></b-form-select>
            </b-col>
            <b-col sm="12" md="6" lg="6" xl="2">
              <label>Data</label>
              <DatePicker
                v-model="pedidoDetail.DATA"
                format="DD/MM/YYYY"
                value-type="YYYY/MM/DD"
                input-class="form-control"
                lang="pt-br"
                disabled
              >
              </DatePicker>
            </b-col>
            <b-col sm="12" md="12" lg="12" xl="12">
              <label>Observação (400 caracteres)</label>
              <b-form-textarea
                id="pedido_observacao"
                v-model="pedidoDetail.OBSERVACAO"
                rows="3"
                max-rows="6"
                maxlength="400"
                :disabled="(this.pedidoDetail.STATUS == 'F')"
              ></b-form-textarea>
            </b-col>
          </b-row>
          <PedidoItens        
            v-show="pedidoDetail.IDCAB > 0"    
            :idPedido="pedido.IDCAB"
            :statusPedido="pedido.STATUS"
          />
        </b-col>
      </b-row>
      <br>
      <b-row cols="12" style="margin-left: 5px;margin-right: 5px;float:right">
        <b-button
          variant="info"
          @click="fecharModal">
          <b-icon icon="backspace"></b-icon>&nbsp;Sair
        </b-button>
        <b-button
          :disabled="this.pedidoDetail.STATUS == 'F'"
          variant="success"
          @click="save">
          <b-icon icon="check2-circle"></b-icon>&nbsp;Salvar
        </b-button>
      </b-row>
  </b-modal>
</template>

<script>
import { naturezaOperacaoOptions } from "@/util/ConstOptions";
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
import PedidoServices from "@/services/Pedido";
import utilServices from "@/services/Util";
import settings from "@/settings";
import PedidoItens from "./itens.vue";

export default {
  name: "PedidoDetails",

  props: {
    pedido: {
      type: Object,
      required: true,
    },

    onCloseModal: {
      type: Function,
      require: true
    }
  },

  components: {
    DatePicker,
    PedidoItens,
  },

  data() {
    return {
      pedidoDetail: {
        IDCAB: 0,
        CLIENTE: 0,
        NAT_OP: 2,
        DATA: "",
        OBSERVACAO: "",
        STATUS: "N",
      },      

      naturezaOperacaoOptions: naturezaOperacaoOptions,

      modalTitle: "",
    };
  },

  methods: {
    save: function() {
      PedidoServices.save(this.pedidoDetail).then(
        (response) => {
          if (response.status === 200) {
            if (response.data.RET == "1") {
              this.$root.$bvToast.toast("Dados salvos com sucesso.", {
                title: "Sucesso",
                variant: "success",
                solid: true,
              });
              this.pedido = response.data.OBJ[0];
              this.carregaDadosPedido();
              
              this.atualizaTituloModal();
            } else {
              this.$root.$bvToast.toast(response.data.OBJ[0].MSG, {
                title: "Erro",
                variant: "danger",
                solid: true,
              });
            }
          }
        },
        (error) => {
          utilServices.parseServerError(error, this);
        }
      );
    },

    carregaDadosPedido() {
      if (this.pedido.IDCAB > 0) {
        this.pedidoDetail = this.pedido;
        if (this.pedidoDetail.STATUS == "N") this.pedidoDetail.STATUS = "E";
      } else {
        this.resetaValoresPedido();
        this.pedidoDetail.CLIENTE = settings.usuarioAutenticado.CLIENTE;
      }
      this.atualizaTituloModal();
    },

    atualizaTituloModal() {
      this.modalTitle =
        "Pedido Número: " +
        this.pedidoDetail.IDCAB +
        " " +
        (this.pedidoDetail.STATUS == "F" ? "(Fechado)" : "(Aberto)");
    },

    resetaValoresPedido() {
      this.pedidoDetail = {
        IDCAB: 0,
        CLIENTE: 0,
        NAT_OP: 2,
        DATA: "",
        OBSERVACAO: "",
        STATUS: "N",
      };
    },

    // fecharPedido() {
    //   this.pedido.STATUS = 'F';
    //   PedidoServices.save(this.pedido).then(
    //     (response) => {
    //       if (response.status === 200) {
    //         if (response.data.RET == "1") {
    //           this.$bvModal.hide("cadastro_pedido");
    //           this.$root.$bvToast.toast("Pedido fechado com sucesso.", {
    //             title: "Sucesso",
    //             variant: "success",
    //             solid: true,
    //           });
    //         } else {
    //           this.$root.$bvToast.toast(response.data.OBJ[0].MSG, {
    //             title: "Erro",
    //             variant: "danger",
    //             solid: true,
    //           });
    //           this.pedido.STATUS = 'E';
    //         }
    //       }
    //     },
    //     (error) => {
    //       utilServices.parseServerError(error, this);
    //     }
    //   );
    // },

    fecharModal() {
      this.$bvModal.hide("cadastro_pedido");
      this.onCloseModal();
    }
  },
};
</script>
